// extracted by mini-css-extract-plugin
module.exports = {"form":"SwitchGroupForm_form__3UfCN"};